import React, { useState } from 'react';
import { Settings as SettingsIcon, Save, Bell, Shield, Database } from 'lucide-react';
import toast from 'react-hot-toast';
import styles from './Settings.module.css';

const Settings = () => {
  const [activeTab, setActiveTab] = useState('general');
  const [isSaving, setIsSaving] = useState(false);

  const handleSave = (e) => {
    e.preventDefault();
    setIsSaving(true);
    setTimeout(() => {
      setIsSaving(false);
      toast.success('System settings saved successfully');
    }, 800);
  };

  return (
    <div className={styles.settingsContainer}>
      <div className={styles.header}>
        <h2>System Settings</h2>
        <p>Configure global application parameters and preferences</p>
      </div>

      <div className={styles.settingsLayout}>
        <div className={styles.sidebar}>
          <button 
            className={`${styles.tabBtn} ${activeTab === 'general' ? styles.activeTab : ''}`}
            onClick={() => setActiveTab('general')}
          >
            <SettingsIcon size={18} /> General
          </button>
          <button 
            className={`${styles.tabBtn} ${activeTab === 'security' ? styles.activeTab : ''}`}
            onClick={() => setActiveTab('security')}
          >
            <Shield size={18} /> Security
          </button>
          <button 
            className={`${styles.tabBtn} ${activeTab === 'notifications' ? styles.activeTab : ''}`}
            onClick={() => setActiveTab('notifications')}
          >
            <Bell size={18} /> Notifications
          </button>
          <button 
            className={`${styles.tabBtn} ${activeTab === 'backup' ? styles.activeTab : ''}`}
            onClick={() => setActiveTab('backup')}
          >
            <Database size={18} /> Data & Backup
          </button>
        </div>

        <div className={styles.contentArea}>
          <div className={styles.settingsCard}>
            <div className={styles.cardHeader}>
              {activeTab === 'general' && <><SettingsIcon size={20} className={styles.icon} /><h3>General Configuration</h3></>}
              {activeTab === 'security' && <><Shield size={20} className={styles.icon} /><h3>Security Settings</h3></>}
              {activeTab === 'notifications' && <><Bell size={20} className={styles.icon} /><h3>Notification Preferences</h3></>}
              {activeTab === 'backup' && <><Database size={20} className={styles.icon} /><h3>Data Management</h3></>}
            </div>
            
            <form onSubmit={handleSave} className={styles.form}>
              {activeTab === 'general' && (
                <>
                  <div className={styles.formGroup}>
                    <label>Application Name</label>
                    <input type="text" defaultValue="Sanskruti Shubh Aangan" />
                  </div>
                  <div className={styles.formGroup}>
                    <label>Support Email</label>
                    <input type="email" defaultValue="support@sanskruti.com" />
                  </div>
                  <div className={styles.formGroup}>
                    <label>Maintenance Mode</label>
                    <select defaultValue="off">
                      <option value="off">Off (System active)</option>
                      <option value="on">On (Show maintenance page)</option>
                    </select>
                    <p className={styles.helpText}>If enabled, only Superadmins can log in to the system.</p>
                  </div>
                </>
              )}

              {activeTab === 'security' && (
                <>
                  <div className={styles.formGroup}>
                    <label>Session Timeout (Minutes)</label>
                    <input type="number" defaultValue="30" />
                  </div>
                  <div className={styles.formGroup}>
                    <label>Two-Factor Authentication</label>
                    <select defaultValue="optional">
                      <option value="optional">Optional for Admins</option>
                      <option value="required">Required for all Admins</option>
                      <option value="disabled">Disabled</option>
                    </select>
                  </div>
                </>
              )}

              {activeTab === 'notifications' && (
                <>
                  <div className={styles.formGroup}>
                    <label>Email Notifications</label>
                    <select defaultValue="all">
                      <option value="all">Send all alerts</option>
                      <option value="critical">Critical alerts only</option>
                      <option value="none">Disable email alerts</option>
                    </select>
                  </div>
                  <div className={styles.formGroup}>
                    <label>SMS Gateway URL</label>
                    <input type="text" placeholder="https://api.sms-provider.com/send" />
                    <p className={styles.helpText}>Leave blank to disable SMS notifications system-wide.</p>
                  </div>
                </>
              )}

              {activeTab === 'backup' && (
                <>
                  <div className={styles.formGroup}>
                    <label>Automated Backups</label>
                    <select defaultValue="daily">
                      <option value="daily">Daily at 2:00 AM</option>
                      <option value="weekly">Weekly on Sundays</option>
                      <option value="manual">Manual only</option>
                    </select>
                  </div>
                  <div className={styles.formGroup}>
                    <label>Data Retention Period</label>
                    <select defaultValue="365">
                      <option value="90">90 Days</option>
                      <option value="365">1 Year</option>
                      <option value="forever">Forever</option>
                    </select>
                    <p className={styles.helpText}>Logs older than this will be automatically archived.</p>
                  </div>
                </>
              )}

              <div className={styles.actions}>
                <button type="submit" className={styles.saveBtn} disabled={isSaving}>
                  <Save size={18} /> {isSaving ? 'Saving...' : 'Save Changes'}
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Settings;
